export default __webpack_public_path__ + "static/media/Inter-italic.var.b27297c1.woff2";